module.exports = __webpack_public_path__ + "static/stripes-right-71751aceebc11ef3e2687eec5a1b3f2d.svg";